import React, { useState, useEffect, useRef } from 'react';
import { createProduct } from '../../../api/products';
import { get_categorias } from '../../../redux/actions/categorias';  
import { connect } from 'react-redux';
import CreatableSelect from 'react-select/creatable';  
import { v4 as uuidv4 } from 'uuid';
import { MdAddPhotoAlternate, MdClose } from 'react-icons/md';
import Portal from '../../ui/Portal';
import styles from '../ProductFormModal.module.css';
import form from '../../../styles/shared/FormDialog.module.css';
import dialog from '../../../styles/shared/Dialog.module.css';
import { selectProps } from '../productSelectStyles';

// Nuevo producto. Mismo modal que EditProductModal (ProductFormModal.module.css): cabecera verde,
// campos con etiqueta en dos columnas y Cancelar | Guardar producto siempre a la vista.
const NewProductModal = ({ onClose, onProductAdded, categorias, get_categorias }) => {
    const [producto, setProducto] = useState({
        seccion: '',
        equipo: '',
        marca: '',
        descripcion: '',
        cantidad: '',
        estado: '',
        fecha_vencimiento: '',
        proveedor: '',
        categoria: '',
        observacion: '',
        reservado: false
    });
    const [images, setImages] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);
    const [currentImageProgress, setCurrentImageProgress] = useState(0);
    const [isProcessingImage, setIsProcessingImage] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const [editedProduct] = useState({ ...producto, newImages: [], removedImages: [] });
    const [selectedCategory, setSelectedCategory] = useState(
       
    );
    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(
        
    );
    useEffect(() => {
        get_categorias();  
    }, [get_categorias]);

    // Escape cierra (salvo que lo use un selector abierto para cerrar su menú)
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !event.defaultPrevented) onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    useEffect(() => {
        if (selectedCategory) {
            const category = categorias.find(cat => cat.nombre === selectedCategory.value);
            if (category) {
                const sectionOptions = category.secciones.map(sec => ({
                    value: sec.nombre,
                    label: sec.nombre
                }));
                setSections(sectionOptions);

                // Set the initial section value
                const initialSection = sectionOptions.find(sec => sec.value === editedProduct.seccion);
                setSelectedSection(initialSection || null);
            }
        } else {
            setSections([]);
            setSelectedSection(null);
        }
    }, [selectedCategory, categorias, editedProduct.seccion]);
    const handleCategoryChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'create-option') {
            setSelectedCategory(newValue);
            setProducto(prev => ({
                ...prev,
                categoria: newValue.value
            }));
        } else {
            setSelectedCategory(newValue);
            setProducto(prev => ({
                ...prev,
                categoria: newValue ? newValue.value : null
            }));
        }
        // Clear section when category changes
        setSelectedSection(null);
        setProducto(prev => ({ ...prev, seccion: null }));
        setSections([]);
    };


    const handleSectionChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'create-option') {
            setSections(prevSections => [
                ...prevSections,
                { value: newValue.value, label: newValue.value }
            ]);
            setSelectedSection(newValue);
            setProducto(prev => ({
                ...prev,
                seccion: newValue.value
            }));
        } else {
            setSelectedSection(newValue);
            setProducto(prev => ({
                ...prev,
                seccion: newValue ? newValue.value : null
            }));
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProducto(prev => ({ ...prev, [name]: value }));
    };
    const compressImage = (file, maxSizeMB, maxWidth, maxHeight) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    let width = img.width;
                    let height = img.height;
    
                    // Resize logic
                    if (width > height) {
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }
                    }
    
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
    
                    const compressAndCheck = (quality) => {
                        setCurrentImageProgress(Math.min(100, 100 - (quality * 100)));
                        canvas.toBlob(
                            (blob) => {
                                if (blob.size > maxSizeMB * 1024 * 1024 && quality > 0.1) {
                                    // If file is still too big, compress further
                                    compressAndCheck(quality - 0.1);
                                } else {
                                    const compressedFile = new File([blob], file.name, {
                                        type: 'image/webp',
                                        lastModified: Date.now(),
                                    });
                                    resolve(compressedFile);
                                }
                            },
                            'image/webp',
                            quality
                        );
                    };
    
                    // Start with quality 0.7 and reduce if necessary
                    compressAndCheck(0.7);
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };
    const handleImageChange = async (e) => {
        const fileInput = e.target;
        const file = fileInput.files[0];
        if (!file) return;
    
        setIsProcessingImage(true);
        setCurrentImageProgress(0);
    
        try {
            const maxSizeMB = 0.5;
            const maxWidth = 500;
            const maxHeight = 667;
    
            const compressedFile = await compressImage(file, maxSizeMB, maxWidth, maxHeight);
            setCurrentImageProgress(100);
    
            const webpFilename = file.name.replace(/\.[^/.]+$/, "") + ".webp";
            const renamedWebp = new File([compressedFile], webpFilename, { type: 'image/webp' });
    
            const previewUrl = URL.createObjectURL(renamedWebp);
    
            const newImage = { id: uuidv4(), file: renamedWebp, previewUrl };
    
            setImages(prev => [...prev, newImage]);
            setPreviewUrls(prev => [...prev, newImage.previewUrl]);
        } catch (error) {
            console.error('Error compressing image:', error);
            setIsProcessingImage(false);
        } finally {
            setIsProcessingImage(false); // Stop processing state after compression
            fileInput.value = ''; // Reset input value to allow uploading the same file again
        }
    };
    
    
    
    const handleRemoveImage = (idToRemove) => {
        const removed = images.find((image) => image.id === idToRemove);
        if (removed) URL.revokeObjectURL(removed.previewUrl);
        setImages(prev => prev.filter((image) => image.id !== idToRemove));
        setPreviewUrls(prev => prev.filter((url, index) => images[index].id !== idToRemove));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        
        // Append other product fields
        Object.keys(producto).forEach(key => {
            if (key === 'observacion') {
                formData.append('observacion', producto.observacion || '');
                return;
            }
            if (producto[key] !== null && producto[key] !== undefined && producto[key] !== '') {
                formData.append(key, producto[key]);
            }
        });
    
        // Append images (ensure correct field name)
        images.forEach((imageObj) => {
            formData.append('images', imageObj.file);
        });
    
        setSubmitting(true);
        setSubmitError('');
        try {
            const response = await createProduct(formData);
            onProductAdded(response.data);
            onClose();
        } catch (error) {
            console.error('Error adding product:', error);
            setSubmitError('No se pudo guardar el producto. Inténtalo de nuevo.');
        } finally {
            setSubmitting(false);
        }
    };
    

    // Las URLs de vista previa se liberan al cerrar el modal. (Antes se liberaban cada vez que cambiaba
    // la lista, y las miniaturas de las imágenes ya agregadas quedaban rotas.)
    const previewUrlsRef = useRef(previewUrls);
    previewUrlsRef.current = previewUrls;
    useEffect(() => () => {
        previewUrlsRef.current.forEach(URL.revokeObjectURL);
    }, []);

    return (
        <Portal>
            <div className={form.overlay}>
                <div
                    className={styles.content}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="new-product-title"
                >
                    <div className={styles.header}>
                        <h2 id="new-product-title" className={styles.title}>Nuevo producto</h2>
                        <button type="button" className={styles.close} onClick={onClose} aria-label="Cerrar">
                            <MdClose aria-hidden="true" />
                        </button>
                    </div>
                    <form className={styles.form} onSubmit={handleSubmit}>
                        <div className={styles.body}>
                            <div className={styles.grid}>
                                <div className={form.field}>
                                    <label htmlFor="categoria" className={form.label}>Categoría</label>
                                    <CreatableSelect
                                        {...selectProps}
                                        inputId="categoria"
                                        placeholder="Elegir o crear"
                                        value={selectedCategory}
                                        onChange={handleCategoryChange}
                                        options={categorias.map(cat => ({
                                            value: cat.nombre,
                                            label: cat.nombre
                                        }))}
                                        formatCreateLabel={(inputValue) => `Crear categoría: ${inputValue}`}
                                    />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="seccion" className={form.label}>Sección</label>
                                    <CreatableSelect
                                        {...selectProps}
                                        inputId="seccion"
                                        placeholder="Elegir o crear"
                                        value={selectedSection}
                                        onChange={handleSectionChange}
                                        options={sections}
                                        formatCreateLabel={(inputValue) => `Crear sección: ${inputValue}`}
                                    />
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <label htmlFor="equipo" className={form.label}>Nombre</label>
                                    <input id="equipo" name="equipo" type="text" className={form.formInput} value={producto.equipo} onChange={handleChange} placeholder="Nombre del producto" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="marca" className={form.label}>Marca</label>
                                    <input id="marca" name="marca" type="text" className={form.formInput} value={producto.marca} onChange={handleChange} placeholder="Marca" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="proveedor" className={form.label}>Proveedor</label>
                                    <input id="proveedor" name="proveedor" type="text" className={form.formInput} value={producto.proveedor} onChange={handleChange} placeholder="Proveedor" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="cantidad" className={form.label}>Cantidad</label>
                                    <input id="cantidad" name="cantidad" type="number" min="0" className={form.formInput} value={producto.cantidad} onChange={handleChange} placeholder="Cantidad" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="estado" className={form.label}>Estado</label>
                                    <input id="estado" name="estado" type="text" className={form.formInput} value={producto.estado} onChange={handleChange} placeholder="Estado" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="fecha_vencimiento" className={form.label}>Fecha de vencimiento</label>
                                    <input id="fecha_vencimiento" name="fecha_vencimiento" type="date" className={form.formInput} value={producto.fecha_vencimiento} onChange={handleChange} />
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <label htmlFor="descripcion" className={form.label}>Descripción</label>
                                    <textarea id="descripcion" name="descripcion" className={`${form.formInput} ${styles.textarea}`} value={producto.descripcion} onChange={handleChange} placeholder="Descripción" />
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <label htmlFor="observacion" className={form.label}>Observación</label>
                                    <textarea
                                        id="observacion"
                                        name="observacion"
                                        className={`${form.formInput} ${styles.textarea}`}
                                        value={producto.observacion}
                                        onChange={handleChange}
                                        placeholder="Observación"
                                        maxLength={100}
                                        aria-describedby="observacion-hint"
                                    />
                                    <p id="observacion-hint" className={form.hint}>
                                        {(producto.observacion || '').length}/100 caracteres
                                    </p>
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <span className={form.label} id="imagenes-label">Imágenes</span>
                                    <div className={styles.images} role="group" aria-labelledby="imagenes-label">
                                        {images.map((image, index) => (
                                            <div key={image.id} className={styles.imagePreview}>
                                                <img src={image.previewUrl} alt={`Imagen ${index + 1}`} />
                                                <button
                                                    type="button"
                                                    className={styles.removeImage}
                                                    onClick={() => handleRemoveImage(image.id)}
                                                    aria-label={`Quitar imagen ${index + 1}`}
                                                    title="Quitar"
                                                >
                                                    <MdClose aria-hidden="true" />
                                                </button>
                                            </div>
                                        ))}
                                        <label className={`${styles.upload} ${isProcessingImage ? styles.uploadDisabled : ''}`}>
                                            <input
                                                type="file"
                                                name="images"
                                                accept="image/*"
                                                multiple
                                                className={styles.fileInput}
                                                onChange={handleImageChange}
                                                disabled={isProcessingImage}
                                            />
                                            <MdAddPhotoAlternate aria-hidden="true" />
                                            Agregar
                                        </label>
                                    </div>
                                    {isProcessingImage && (
                                        <div className={styles.progress}>
                                            <progress value={currentImageProgress} max="100" aria-label="Procesando imagen" />
                                            <span>{currentImageProgress.toFixed(0)}%</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={styles.footer}>
                            {submitError && <p className={`${form.formError} ${styles.error}`} role="alert">{submitError}</p>}
                            <div className={`${dialog.buttons} ${form.buttons} ${styles.buttons}`}>
                                <button type="button" className={dialog.cancelButton} onClick={onClose}>Cancelar</button>
                                <button type="submit" className={dialog.confirmButton} disabled={submitting || isProcessingImage}>
                                    {submitting ? 'Guardando...' : 'Guardar producto'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Portal>
    );
};

const mapStateToProps = (state) => ({
    categorias: state.Categorias.categorias,
});

export default connect(mapStateToProps, { get_categorias })(NewProductModal);